<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    align?: 'left' | 'center' | 'right';
    attached?: boolean;
  }>(),
  { align: 'left' },
);

const justify = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

// Elke regel staat er twee keer: de knop is niet altijd een direct kind (VMultipleChoiceButtons
// hangt er een VTooltip tussen), maar de positie moet van het directe kind komen.
const attachedClasses = [
  '[&>:is(button,a):not(:first-child)]:rounded-l-none',
  '[&>*:not(:first-child)_:is(button,a)]:rounded-l-none',
  '[&>:is(button,a):not(:last-child)]:rounded-r-none',
  '[&>*:not(:last-child)_:is(button,a)]:rounded-r-none',
  '[&>:is(button,a):not(:first-child)]:border-l-0',
  '[&>*:not(:first-child)_:is(button,a)]:border-l-0',
].join(' ');
</script>

<template>
  <div
    class="flex flex-wrap"
    :class="{
      [justify[props.align]]: true,
      [`group/v-button-group--attached ${attachedClasses}`]: props.attached,
      'items-center gap-2': !props.attached,
    }"
  >
    <slot></slot>
  </div>
</template>
